<script setup lang="ts">
import { odsBox } from 'omind-design-system/components/odsBox';
import { odsButton } from 'omind-design-system/components/odsButton';
import { odsCheckbox } from 'omind-design-system/components/odsCheckbox';
import { closePopup, PopupSize, usePopup } from "omind-design-system/components/odsPopup";
import { FlexDirection, Spacing } from 'omind-design-system/tokens';
import LegalPopup from './LegalPopup.vue';
import { ref } from 'vue';
import { useSessionStore } from '@/domains/-session/stores/useSessionStore.ts';

const accept = ref(false)

function openLegalTerms() {
    usePopup(LegalPopup, {
        id: 'popup-legal',
        canClose: true,
        size: PopupSize.XL,
        overflow: true,
        specificClass: '',
        componentProps: {

        }
    })
}

function acceptLegalTerms() {
    const session = useSessionStore()
    session.setAcceptedLegal()
    closePopup('popup-accept-legal')
}

</script>

<template>
    <odsBox :direction="FlexDirection.Column" :padding="Spacing.None" :gap="Spacing.Large" class="legal-popup">
        <h2 v-html="$t('legal.popup.title')"></h2>
        <p v-html="$t('legal.popup.desc')" style="align-self: flex-start;"></p>
        <odsCheckbox id="accept_legal" @change="value => accept = value">
            <span>
                <span v-html="$t('legal.popup.accept')"></span>
                <a href="#" @click.prevent="openLegalTerms" v-html="$t('legal.popup.link')"></a>
            </span>
        </odsCheckbox>
        <odsButton :label="$t('legal.popup.cta')" :disabled="!accept" @click="acceptLegalTerms"></odsButton>
    </odsBox>
</template>

<style lang="scss">
.legal-popup {
    h2 {
        color: #1F3049;
        text-align: center;
        font-size: 1.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: 0.024rem;
    }

    p {
        color: #1F3049;
        font-size: 0.875rem;
        font-style: normal;
        font-weight: 400;
        line-height: 160%;
        letter-spacing: 0.014rem;
        opacity: 0.64;
    }

    .ods-checkbox {
        &>.checkbox-container {
            &>span {
                color: var(--content-label-900, #000A29);
                font-size: 0.875rem;
                font-style: normal;
                font-weight: 400;
                line-height: 1rem;
                /* 114.286% */
                letter-spacing: 0.014rem;

                a {
                    color: var(--content-label-900, #000A29);
                    font-family: Inter;
                    font-size: 0.875rem;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 1rem;
                    letter-spacing: 0.014rem;
                    text-decoration-line: underline;
                    text-decoration-style: solid;
                    text-decoration-skip-ink: none;
                    text-decoration-thickness: auto;
                    text-underline-offset: auto;
                    text-underline-position: from-font;
                }
            }
        }
    }
}
</style>